import * as React from 'react'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import { useTheme } from '@mui/material/styles'

interface Props {
  children?: React.ReactNode
  title: string
}

export function SettingsHomeSectionTidal(props: Props) {
  const { children, title } = props
  const theme = useTheme()
  return (
    <Stack
      sx={{
        width: '100%', // ⬅️ adapt to small screens
        maxWidth: 766, // ⬅️ same visual cap as before
        mb: 4,
        mx: 'auto', // ⬅️ center inside parent
      }}
    >
      <Typography
        variant="h6"
        mb={2}
        sx={{ color: theme.palette.text.primary }}
      >
        {title}
      </Typography>
      {children}
    </Stack>
  )
}
